import { isArray, isNull, isUndefined } from "../../util/TypeUtil";
import Content from "./Content";
import ContentTypes from "./ContentTypes";
import MCOption from "./MCOption";

/**
* MCBlock.js
* 
* Created on Nov 7, 2013, 10:55:29 AM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
export default class MCBlock extends Content {
    constructor(languagePack, contentID, options, label) {
        super(MCBlock.NAME, MCBlock.TYPE, null, languagePack, contentID);

        this._contentID = !isUndefined(contentID) ? contentID : null;
        this._options = [];
        this._label = !isUndefined(label) ? label : null;

        for (const option in options) {
            this._options.push(option);
        }
        this._selectedOptionIndex = -1;

    }

    getSelectedOption() {
        return this._selectedOptionIndex > -1 ? this._options[this._selectedOptionIndex] : null;
    }

    setSelectedOption(option) {
        this._selectedOptionIndex = this._options.indexOf(option);
    }

    getSelectedOptionIndex() {
        return this._selectedOptionIndex;
    }

    getOptions() {
        return this._options;
    }

    addOption(option) {
        this._options.push(option);
    }

    removeOption(option) {
        this._options.remove(option);
        this._selectedOptionIndex = -1;
    }

    convertToObject() {
        const object = super.convertToObject();
        object.selectedOptionIndex = this._selectedOptionIndex;
        object.options = [];
        for (let i = 0; i < this._options.length; i++) {
            object.options[i] = this._options[i].convertToObject();
        }
        return object;
    }

    setPropertiesFromObject(object) {
        if (!isNull(object.options) && isArray(object.options)) {
            for (let i = 0; i < object.options.length; i++) {
                const option = new MCOption(this._languagePack);
                option.setPropertiesFromObject(object.options[i]);
                this.addOption(option);
            }
            delete object.options;
        }

        if (!isNull(object.selectedOptionIndex)) {
            this._selectedOptionIndex = object.selectedOptionIndex;
            delete object.selectedOptionIndex;
        }
        // Call Super
        super.setPropertiesFromObject(object);
    }

    // TODO: implement export csv text
    //       exportText(csv){
    //           
    //       }
}

MCBlock.NAME = "MC Text Block";
MCBlock.TYPE = ContentTypes.TYPE_MCBLOCK;

